module.exports = __webpack_public_path__ + "img/trainingdis.89b4291b.svg";